import { Calendar, Search } from 'lucide-react';
import { Button } from './ui/button';

export const EmptyState = ({ 
  title = "Nenhuma prova encontrada",
  description = "Tenta ajustar os filtros ou pesquisa",
  showReset = false,
  onReset
}) => {
  return (
    <div className="empty-state py-20" data-testid="empty-state">
      <div className="w-20 h-20 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-6">
        <Search className="text-slate-400" size={40} />
      </div>
      <h3 
        className="text-2xl font-bold text-slate-900 dark:text-white mb-2"
        style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
      >
        {title}
      </h3>
      <p className="text-slate-500 dark:text-slate-400 mb-6 max-w-md">
        {description}
      </p>
      {showReset && onReset && (
        <Button 
          onClick={onReset}
          className="bg-red-600 hover:bg-red-700 text-white"
          data-testid="reset-filters-btn"
        >
          Limpar filtros
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
